import { z } from "zod";

const translationPath = "page.totem_start.errors.";
const typeSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "environment" }
);

export const totemStartSchema = z.object({
  code: z.string().nonempty(translationPath + "login"),
  password: z.string().min(6, translationPath + "password"),
  environment: typeSchema,
});

export type TTotemStartFormData = z.infer<typeof totemStartSchema>;
